import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <p class="reason">
  <PinnedOptions @value={{this.pinned}} @topic={{this.topic}} />
  <span class="text">{{html-safe this.reasonText}}</span>
</p>
*/
{
  "id": "c4/fzxJH",
  "block": "[[[10,2],[14,0,\"reason\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@value\",\"@topic\"],[[30,0,[\"pinned\"]],[30,0,[\"topic\"]]]],null],[1,\"\\n  \"],[10,1],[14,0,\"text\"],[12],[1,[28,[35,1],[[30,0,[\"reasonText\"]]],null]],[13],[1,\"\\n\"],[13]],[],false,[\"pinned-options\",\"html-safe\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/pinned-button.hbs",
  "isStrictMode": false
});